import { createSlice } from '@reduxjs/toolkit';

interface visibleModel {
    isVisible: boolean
}

const initialState = {
    isVisible: false,
    
}
const settingSlice = createSlice({
    name: 'modalVisible',
    initialState,
    reducers: {
        changeModalVisibility(state: visibleModel, action: { payload: boolean}) {
            state.isVisible = action.payload
        }
    }
});
export const {
    changeModalVisibility
} = settingSlice.actions;
export default settingSlice.reducer;